import React from 'react';
import { UISize, UIVariant } from '@gik/ui/types';
import bemBlock from '@gik/core/utils/bemBlock';

export interface ISeparatorProps extends React.HTMLAttributes<HTMLHRElement> {
  variant?: UIVariant | 'danger' | 'success';
  type?: 'solid' | 'dashed' | 'dotted';
  thickness?: 'normal' | 'double';
  size?: 'none' | UISize;
  className?: string;
  direction?: 'horizontal' | 'vertical';
}

const blockName = 'separator';

function Separator(
  {
    variant = 'default',
    type = 'solid',
    thickness = 'normal',
    size = 'base',
    direction = 'horizontal',
    className,
    children,
  }: React.PropsWithChildren<ISeparatorProps>,
  ref
) {
  const bem = bemBlock(blockName);
  const modifiers = [
    {
      [variant]: variant,
    },
    {
      [size]: size,
    },
    {
      [direction]: direction,
    },
    {
      [type]: type,
    },
    {
      [thickness]: thickness,
    },
    {
      'with-content': children !== undefined,
    },
  ];

  return (
    <>
      {children ? (
        <div ref={ref} className={bem(null, modifiers, className)}>
          {children}
        </div>
      ) : (
        <hr ref={ref} className={bem(null, modifiers, className)} />
      )}
    </>
  );
}

export default React.forwardRef(Separator);
